import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { DiscordAuthContextProvider } from "./hooks/useDiscordAuthContext";
import { App } from "./App";

const container = document.getElementById("app");
const root = container && createRoot(container);
root?.render(<StrictMode><DiscordAuthContextProvider><App /></DiscordAuthContextProvider></StrictMode>);
